import styled, { CSSProperties } from 'styled-components';

export const EmissionWrapper = styled.div<{ $resultSegments: number }>`
  display: grid;
  gap: 1.5rem; 
  margin-bottom: 2rem; 

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1540px) {
    grid-template-columns: repeat(${props => props.$resultSegments || 4}, minmax(0, 1fr));
  }
`;

export const Card = styled.div`
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  background-color: white;
  color: #1a1a1a;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  min-height: 160px;  
  min-width: 280px;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.375rem;
  padding: .5rem;
`;

export const CardContent = styled.div`
  padding: 1.5rem;
  padding-top: 0;
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 2rem;
  width: 100%;
`;

const Segment = styled.div<{ $widthSegment?: CSSProperties['width'] }>`
  flex: 1;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  min-width: ${props => props.$widthSegment ?? '450px'};
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const SmallCard = styled.div<{ $border?: CSSProperties['border'] }>`
  background: #f8f9fa;
  border: ${props => props.$border || '1px solid #e9ecef'};
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SmallCardLabel = styled.span`
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
  display: flex;
  align-items: baseline;
  max-width: 350px;
  white-space: nowrap; 
  overflow: hidden;   
  text-overflow: ellipsis;
  gap: 5px;
`;

const SmallCardValue = styled.span`
  font-size: 14px;
  color: #212529;
  display: flex;
  align-items: center;
  font-weight: bold;
  gap: 5px;
  .unit {
    font-size: 12px !important;
  }
`;

const ChartContainer = styled.div`
  height: 400px;
  width: 100%;
`;

const SegmentTitle = styled.h3`
  margin: 0 0 20px 0;
  color: #495057;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 10px;
`;

export const TabEl = {
  ContentWrapper,
  SegmentTitle,
  ChartContainer,
  SmallCardValue,
  SmallCardLabel,
  SmallCard,
  Segment
}